import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth28: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M5.3,63.5l.7-15.9,8.4-7.8,9.8-5.9,11-4.7,11-3.1,9.6-1,11.3,1,9.8,1.2,10.3,1.2,8.4,1.9,7.8,3.5,6.1,3.5,12.9-4.5,11-2.1h20.3l11.3,3.9,11.3,9.2,7.5,11.5,3.1,9,.4,9.8-.2,14.5-1.4,13.5-1.9,9.8-3.5,12.3s-41.6,37-153.4,7.2l-7.6-18.4-8.6-29.3-5.3-20.2h0Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M112.8,75.4a14,14 0 1,1 -28,0a14,14 0 1,1 28,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M55.5,26.4v60.2s1.6,17.5-12.4,17.5h-25.5l-11.5-37.9v-15.7l4-6.5,5.3-4.1,6.8-4.3,7.6-3.4,7.7-2.9,7.8-2.1s10.3-.9,10.3-.9Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M135.3,32.6l15.4-.3,8.5,1.7,6.8,3.1,6.5,5.1,5.7,6,4.4,8,2.8,8.1,1.2,4.8v17.8l-1,8.2-1.6,9.3h-35.3s-13.6,2.5-13.6-11.3l.2-60.6h0Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M26.9,131.4s101.2,30,153.4-7.2l-6,12.5s-44.6,37.8-144.6,2.5l-2.9-7.7h0Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.5,37.5l-13.9-7-18.7-3.1-21.1-2.1-9.6,1-11,3.1-11,4.7-9.8,5.9-8.4,7.8-1,7.6v7.6l1.8,9.8,6.5,18.9,5.9,21.6,7.6,18.4c35.7,10.4,70.8,11.5,70.8,11.5,0,0-25.7-78.2,11.9-105.5h0Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.3,124.2l3.5-12.3,1.9-9.8,1.4-13.5.2-14.5-.4-9.8-3.1-9-7.5-11.5-11.3-9.2-11.3-3.9h-20.3l-11,2.1-12.9,4.5s-37.1,17.6-11.9,105.5c0,0,54.8,3.2,82.6-18.7h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.1 77.3 32.1 58.2 36.4 88.9 53.4 56.2 68.2 90 83.6 55.8 99.8 87.7 115.1 54.4 130.6 88.1 145.2 53.8 158.5 87.2 167.7 56.7 185.7 78.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'101.7 103.3 89 110.9 103.9 119.3 91.1 127 104.9 134.9 92.7 142.2 105 149.2 93.3 156.4 107.5 164.4 95.9 171.2 107.3 177.6 95.7 184.6 108.2 191.5 95.9 198.9 107.6 205.4 95.3 212.7 106.3 219 94.3 226.1 107.5 233.7 93.6 242 106.3 249.4 92.5 257.5 105.7 265 92.1 273.1 107 281.6 94.5 289.1 108.5 297.1 93.6 305.9 106.9 313.4 93.4 321.4 107.4 329.3 93 340.2 107 345.7 92.7 357.1 108.1 361.6 96.6 381.2',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'149.8 251.3 142.7 237.5 133.3 251.4 123.4 238.6 114.1 251.4 102.2 237.3 90.4 251.4 79.8 237.5 66.9 253.7 56.1 238.9 45.5 253.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.3,56.1l3.5-8,2.2-2.6,2-2.3,1.8-2,4-3.5,4.5-2.4,3.9-2.3,4-2,4.5-1.6,4.5-1,4.2-.8s1-.2,2.2-.2,6.4.4,6.4.4l2.9.2,4.9,1.4,2.6,1.2,4.9,1.3,3.7,1.3,5.5,1.6,3.7,1,2.6.6,10.5.2h4.5l3.9.4,5.7,1.4,5,2.2,4.5,2.4,7,3.9,5.2,4.5,4.9,4.4,3.4,3.5,1.3,2.2,1.4,3.7,1.6,2.9,1,7.8s.6,3.5.6,4,.6,6,.6,6l9.1,30,.2,5.4.2,6.4-.4,7.4-.4,5.8-1.2,4-1.8,5.4-2.2,4-3.4,6.2-3.2,4.2-5.5,3.7-6.4,4.5-5.8,2.2-2.9,2-6.2,2.6-4,.8-6.7,1.3-7,1.6-11.3.6-5.7.8-3.5.2-4.4-.2-7.8.4h-3.5l-4.2-1-8.4-2.3-5.7-2.2-4-2.9-3.4-3.2-3.4-3.4-2.4-2.6-3.1-4.4-5-9.7-5-11.5-5-10.3-4.2-12.1-2-9.7-3.1-24.2.2-15.1,1-7.6,1.8-7h.4Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.4,150.4l-2.4-7.4-4.9-8.7-4-13.1-4.5-16.1-1.8-14.3-.2-14,.9-10.5,2.7-10.3,29.6,27.1s23.9,15.5,9.4,37.2l-24.6,30.1h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M157.4,62.6l3.4,6.1,1.1,10.4,1.1,6.1,6.3,16.2,2.9,10.6.5,7.2.2,15.1-3.2,15.7-32.2-25.5-2.5-2.2s-16.7-14.1-2.5-28.7l7.2-8.6,17.8-22.4h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.3,34l-21.4-7-12.6-.2-13.9,5-9.5,5.9-7.4,6.1-4.7,6.7-1.7,5.5,29.6,27.1s27.4,11.6,33.9,2c6.5-9.6,8.9-19.6,7.6-51.1Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.3,34l7,2.3,12.1-.5,9.5,1.4,10.1,3.4,8.6,4.7,7.2,5.2,5.4,5,3.2,7-17.8,22.4s-19.1,7-24.3,1.4c-17.1-18.4-28.6-1.3-28.6-1.3,0,0,9.3-21.8,7.6-51.1h0Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.6,149.9l-4.8,8.4-8.6,9.8-11.6,7.4-14.8,5.9-12.3,2.3-10,.9s-2.1-27,11.7-42.6c13.8-15.7,7.9-11.1,8.9-14.5,1.4-5.1-.4-7.4-.4-7.4l9.5,4.3,32.2,25.5h.2Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107.6,184.7h-29.7l-14.2-3.1-10.8-8-7.4-8.3-8.2-14.9,24.6-30.1s7.3-4.8,15.7-4.8,12.6,9,22.3,9,9.5-7.5,18.3-7.5,9.6,3.1,9.4,3.1c6.7,8.3-8.5,21.9-8.5,21.9,0,0-12.3,12.7-11.7,42.6h.2Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M52.8,83s27.3,11.2,33.9,2c9.6-13.3,22.5-5.9,28.6,1.3,6.1,7.2,21.9-1.4,24.3-1.4s-24.9,18.9-4.7,37.3l2.5,2.2s-15.7-7.5-19-7.5-7.4,7.5-18.3,7.5-15.2-9-22.3-9-15.7,4.8-15.7,4.8c-8.8,6.7,20.3-15-9.4-37.2h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'170.6 113.2 156.3 89.8 148.7 121.2 138.8 82.7 125.7 122.2 113.7 82.7 100.2 121.7 87.6 82.7 74.2 124.2 63.1 84.8 48.6 124.2 44.1 91.2 25.7 112.7',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.4,372.5l3.8,12.4,1.2,10.5,1.7,13,.8,7.9-.7,7.5-1.5,6.7-2.5,7.1-4.6,5.8-1.5,6.5-2.9,8.4-4.6,7.5-5.7,4.8-7.5,3.8-11.5,2.7-6.3.4-12,.2-21.3-3.6h-12l-18,5.7-25.6.2-15.1-3.4-15.3-5-9.2-8.2-3.4-9-1-9.4.8-9.2,3.6-15.5,14.1-33.3s63.6-32.3,156-14.6h.3Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.4,387.2s63.1-32.3,156-14.6l-2.5-7.7s-83.4-23.9-149.3,12.5l-4.3,9.8h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M118,417.4a13.1,13.1 0 1,1 -26.2,0a13.1,13.1 0 1,1 26.2,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.8,405.6h37.7s9.2,1.5,9.2,11.3v63l-13.4.2-19.4-4.2-13.6-5.8-7.4-6.9-3.8-9.2-.7-15.8,3.8-15.8,7.5-17h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M189.3,405.2h-44.8s-9.6,2.5-9.6,10.7.7,62,.7,62l22.8-3.4,9-4,7.5-7.5,4.6-9.4,2.7-10.5,5.7-7.9,3.1-11.3v-13l-1.7-5.7h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.8,473.9l12.4,1.7,14.2,2.1h12.7l13.9-3.1,11.3-5.7,6.3-8.2,3.8-8.6,1.5-7.7,6.3-9.8,2.7-12.5v-13.9l-2.3-18.4-5.1-17.2s-33.3-6.5-59.4-5.2c0,0,7.7,26.3-2.7,42.1-10.6,15.8-15.5,64.5-15.5,64.5h-.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.4,387.2l-14.1,33.3-3.6,15.5-.8,9.2,1,9.4,3.4,9,9.2,8.2,15.3,5,15.1,3.4,25.6-.2,18-5.7,9.3-.4s4.7-47.6,15.5-64.5c10.3-16.1,2.7-42.1,2.7-42.1,0,0-52.3-.8-96.7,19.9h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'186.1 432.3 169.5 407.2 160.1 442.1 148.7 399.4 132.6 442.9 118.7 399.1 101.9 442.1 87.5 398.7 70.7 444.5 58.2 400.6 40.2 444.1 35.2 407.4 11.7 431.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'160.6 155.3 164.5 170.8 151.8 173.5 161.4 186.2 147.1 189.9 159.9 200.4 147.2 203.5 154.9 213.2 142.9 218.1 152.8 227.5 139.6 232.6 151.5 240.9 137.5 245 149.3 254 136.6 259.4 146.8 267 136.2 271.6 146.6 279.5 135.4 284.3 145.8 292.2 133.8 297.2 143.7 304.7 132.7 309.4 142.6 316.8 128.9 322.7 138.9 330.3 127 335.4 137.3 343.3 124.1 349 134.9 357.3 120.6 363.4 131.3 371.6',
				'66.2 373.4 77.9 362.2 64.7 356.5 75.6 347.5 62.1 342.2 73.7 333.7 62.3 327.7 72.8 320.9 59.6 314 70 307.4 59.4 301.9 69.8 295.2 58.3 289.2 69.2 282.1 58.4 276.5 69.4 269.5 59.2 264.1 69.9 257.2 57.7 250.8 70.2 242.8 58.4 236.4 70.7 228.6 58.5 222.2 70.5 216.6 58.5 208.9 70.5 203.5 58.5 194.6 71.6 189.6 62.4 180 75.5 174.6 67.8 162.7 80.1 162.3 77 146.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'165.2 263.2 156.9 247 141.6 264.8 132.1 247.2 118.3 264.2 105.1 246.2 94.6 264.8 81.5 246.1 65.8 264.9 52.9 247.4 39.2 264.4',
			],
		},
	},
};
